import { calendarDay } from '../../../../engine/core/calendar-day.js';

export function ganttCenterDay(scroller) {
  const { startDay, dayWidth, labelWidth } = scroller.dataset;
  return Number(startDay) + (scroller.scrollLeft + scroller.clientWidth / 2 - Number(labelWidth)) / Number(dayWidth);
}

/** Capture the task under the viewport center before changing row height. */
export function ganttRowAnchor(scroller) {
  const position = (scroller.scrollTop + scroller.clientHeight / 2 - Number(scroller.dataset.axisHeight))
    / Number(scroller.dataset.rowHeight);
  const index = Math.floor(position);
  // Rows are drawn near the screen only (render/timeline.js): find by index.
  const row = scroller.querySelector(`.mobile-gantt-rows > g[data-row-index="${index}"]`);
  return row ? { nodeId: row.dataset.nodeId, fraction: position - index } : null;
}

/** Keep the same date visible across renders and grow the calendar at either edge. */
export function attachGanttScroll(scroller, uiState, { today, centerDay, scheduleRender, redrawRows }) {
  const startDay = Number(scroller.dataset.startDay);
  const endDay = Number(scroller.dataset.endDay);
  const dayWidth = Number(scroller.dataset.dayWidth);
  const labelWidth = Number(scroller.dataset.labelWidth);
  uiState.ganttBounds = { startDay, endDay };
  uiState.ganttViewportWidth = scroller.clientWidth;
  const anchor = today ? calendarDay(new Date()) : centerDay ?? uiState.ganttCenterDay;
  if (anchor != null) {
    scroller.scrollLeft = Math.max(0, labelWidth + (anchor - startDay) * dayWidth - scroller.clientWidth / 2);
  }
  uiState.ganttCenterDay = ganttCenterDay(scroller);
  scroller.scrollTop = uiState.ganttScrollTop || 0;
  const rowAnchor = uiState.ganttRowAnchor;
  uiState.ganttRowAnchor = null;
  if (rowAnchor) {
    const row = scroller.querySelector(`.mobile-gantt-rows > g[data-node-id="${CSS.escape(rowAnchor.nodeId)}"]`);
    const index = row ? Number(row.dataset.rowIndex) : -1;
    if (index >= 0) {
      scroller.scrollTop = Number(scroller.dataset.axisHeight)
        + (index + rowAnchor.fraction) * Number(scroller.dataset.rowHeight) - scroller.clientHeight / 2;
    }
  }
  uiState.ganttScrollTop = scroller.scrollTop;
  redrawRows?.(scroller); // the scroll may differ from where rows were drawn
  let extending = false;
  scroller.addEventListener('scroll', () => {
    uiState.ganttCenterDay = ganttCenterDay(scroller);
    uiState.ganttScrollTop = scroller.scrollTop;
    redrawRows?.(scroller);
    if (extending) return;
    const threshold = scroller.clientWidth * 0.75;
    const padding = Math.ceil(2 * scroller.clientWidth / dayWidth);
    const nearStart = scroller.scrollLeft < threshold;
    const nearEnd = scroller.scrollWidth - scroller.scrollLeft - scroller.clientWidth < threshold;
    if (!nearStart && !nearEnd) return;
    extending = true;
    uiState.ganttBounds = {
      startDay: startDay - (nearStart ? padding : 0),
      endDay: endDay + (nearEnd ? padding : 0),
    };
    scheduleRender();
  }, { passive: true });
}
